/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Date_Of_Birth_QuestionInputs */

const en_us2_onboarding_date_of_birth_question = /** @type {(inputs: Onboarding_Date_Of_Birth_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When were you born?`)
};

const pt_br2_onboarding_date_of_birth_question = /** @type {(inputs: Onboarding_Date_Of_Birth_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando você nasceu?`)
};

const es_419_onboarding_date_of_birth_question = /** @type {(inputs: Onboarding_Date_Of_Birth_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuándo naciste?`)
};

const pt_pt2_onboarding_date_of_birth_question = /** @type {(inputs: Onboarding_Date_Of_Birth_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando nasceste?`)
};

const fr_fr2_onboarding_date_of_birth_question = /** @type {(inputs: Onboarding_Date_Of_Birth_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est ta date de naissance ?`)
};

const de_de2_onboarding_date_of_birth_question = /** @type {(inputs: Onboarding_Date_Of_Birth_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wann bist du geboren?`)
};

const it_it2_onboarding_date_of_birth_question = /** @type {(inputs: Onboarding_Date_Of_Birth_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la tua data di nascita?`)
};

/**
* | output |
* | --- |
* | "When were you born?" |
*
* @param {Onboarding_Date_Of_Birth_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_date_of_birth_question = /** @type {((inputs?: Onboarding_Date_Of_Birth_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Date_Of_Birth_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_date_of_birth_question(inputs)
	if (locale === "es-419") return es_419_onboarding_date_of_birth_question(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_date_of_birth_question(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_date_of_birth_question(inputs)
	if (locale === "de-DE") return de_de2_onboarding_date_of_birth_question(inputs)
	if (locale === "it-IT") return it_it2_onboarding_date_of_birth_question(inputs)
	return en_us2_onboarding_date_of_birth_question(inputs)
});
export { onboarding_date_of_birth_question as "onboarding.date_of_birth.question" }